<template>
	<span v-html="require(`!!svg-inline-loader?removeSVGTagAttrs=false!../../../../assets/images/${src}`)" />
</template>

<script>
export default {
	props: {
		src: {
			type: String,
			required: true,
		},
	},
};
</script>
